import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button/Button";
import { ReactComponent as SuccessIcon } from "../../assests/svg/Success.svg";
import { useTranslation } from "react-i18next";

const SupplierMapSuccess = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const history = useNavigate();

  const goToSupplierMap = () => {
    history("/supplier-mapping-dashboard");
  };

  const goToClientMap = () => {
    history("/clients-mapping-dashboard");
  };

  return (
    <div className="d-flex flex-column  align-item-center bg-light w-100 py-5 gap-2">
      <div className="d-flex flex-row w-100 justify-content-center">
        <SuccessIcon />
      </div>
      <div className="d-flex flex-row w-100 justify-content-center mt-2">
        <span className="text-dark font-bold font-40">
          {t("Supplier mapped successfully")}
        </span>
      </div>
      <div className="d-flex flex-row w-100 justify-content-center mt-2">
        <Button type={"primary"} text={t("Supplier Dashboard")} onClick={() => goToSupplierMap()} />
      </div>
      <div className="d-flex flex-row w-100 justify-content-center mt-2">
        <Button type={"rounded"} text={t("Map client to product")} onClick={() => goToClientMap()} />
      </div>
    </div>
  );
};

export default SupplierMapSuccess;
